import { useCallback, useEffect, useState } from "react";
var CryptoJS = require("crypto-js");

const Auth = () => {
  const [authenticated, setauthenticated] = useState(false);
  var ciphertext = (data) =>
    CryptoJS.AES.encrypt(JSON.stringify(data), "secret-key@CG").toString();

  var bytes = (data) => CryptoJS.AES.decrypt(data, "secret-key@CG");
  var decryptedData = (data) => JSON.parse(data.toString(CryptoJS.enc.Utf8));

  const login = useCallback((cb) => {
    let details = cb();
    let data = {
      userId: details.userId,
      username: details.username,
      role: details.role,
      jwt: details.jwt,
      district: details.district,
      isViewOnly: details.isViewOnly,
      roleMasterId: details.roleMasterId,
    };
    setauthenticated(data);

    localStorage.setItem("user", ciphertext(data));
  }, []);

  const logout = useCallback((cb) => {
    setauthenticated(null);
    localStorage.removeItem("user");
    localStorage.removeItem("bidderLotListSearch");
    cb();
  }, []);

  useEffect(() => {
    //
    if (localStorage.getItem("user")) {
      ////
      const storedData = decryptedData(bytes(localStorage.getItem("user")));
      if (storedData && storedData.jwt) {
        login(() => {
          //
          return {
            userId: storedData.userId,
            username: storedData.username,
            role: storedData.role,
            jwt: storedData.jwt,
            district: storedData.district,
            isViewOnly: storedData.isViewOnly,
            roleMasterId: storedData.roleMasterId,
          };
        });
      }
    }
  }, [login]);

  return { login, logout, authenticated };
};

export default Auth;
